/**
 * external dependencies
 */
import { TabulatorFull, Options, CellComponent, ColumnDefinition } from 'tabulator-tables';

/**
 * internal dependencies
 */
import { IPortalUser } from '../../models/user.interface';
import { tableSearchInput } from './table-helpers';

import GetUsers from '../../routes/get-users';

/**
 * Displays a list of portal users
 * 
 * @returns void
 */
export const userListTable = async () => {
  const userTable = document.querySelector('.aafp_user-list') as HTMLElement;
  if(!userTable) return; 

  const { body } = await GetUsers();

  displayUserTable( body, userTable );
}

/**
 * Creates a table to display portal user data
 * 
 * @param {object} data the user object
 * @param {HTMLElement} element the root element for the table
 * 
 * @returns void
 */
const displayUserTable = (data: IPortalUser[], element: HTMLElement) => {

  /**
   * Formats the link button for the user
   * 
   * @param {CellComponent} cell the cell component
   * @param {any} formatterParams the formatter parameters 
   * 
   * @returns string
   */
  const link_button = (cell: CellComponent, formatterParams: any) => {
    let data = cell.getData() as IPortalUser;
    let access = '';
    let level = data.Role;
    if (level === 'Partner Admin' || level === 'Partner Reporting') {
      access = 'P';
    } else if ( level === 'Customer Admin' || level === 'Customer Reporting') {
      access = 'C';
    } else if ( level === 'Site Admin' || level === 'Site Reporting') {
      access = 'B';
    } else if ( level === 'Card Group Reporting') {
      access = 'G';
    } else if ( level === 'Aag Admin' || level === 'Aag Reporting') {
      access = 'A';
    }

    return `<a class='aafp_btn-table btn_theme-primary' 
            href='/portal-users/portal-user-edit?userID=${data.UniqueID}&al=${access}' 
            data-toggle='tooltip' 
            data-placement='bottom' 
            title='View ${data.Name}'><i class='far fa-eye'></i></a>`;
  }

  /**
   * Formats the status of the user
   * 
   * @param {CellComponent} cell the cell component
   * @param {any} formatterParams the formatter parameters
   * 
   * @returns string
   */
  const formatStatus = (cell: CellComponent, formatterParams: any) => {
    let data = cell.getData() as IPortalUser;
    let status = data.Status;
    let statusClass = status === 'Active' ? 'aafp_status-active' : 'aafp_status-inactive';
    return `<span class='${statusClass}'>${status}</span>`;
  }
  
  const columnDefinition: ColumnDefinition[] = [
    { title: "ID", field: "ID", visible: false },      
    { title: 'Name', field: 'Name', sorter: "string", resizable: false, vertAlign: 'middle' },
    { title: 'Email', field: 'Email', sorter: "string", resizable: false, vertAlign: 'middle' },
    { title: 'Role', field: 'Role', sorter: "string", resizable: false, vertAlign: 'middle' },  
    { title: 'Status', field: 'Status', formatter: formatStatus, cssClass: "aafp_column-button-wide", sorter: "string", resizable: false, width: 40, vertAlign: 'middle' },
    { title: '', field: "LinkButton", formatter: link_button, cssClass: "aafp_column-button", hozAlign: 'center', width: 40, resizable: false, headerSort: false },    
  ];

  const options: Options = {
    index: 'ID',
    data: data,
    pagination: true,
    paginationMode: "local",
    paginationSize: 10,
    paginationSizeSelector: [25, 50, 75],
    paginationCounter: "rows",
    layoutColumnsOnNewData: true,
    selectable: false,
    columns: columnDefinition
  };

  const userTableGrid = new TabulatorFull(element, options);
  let userListSort = document.querySelector('#aafp_user-list-sort') as HTMLInputElement;  
  tableSearchInput(userListSort, userTableGrid);
}